export default "__VITE_ASSET__f0a27275__$_?component__"